import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Welcome To Buy or Rent Properties',
  description: 'We sell and rent properties',
  keywords: 'Land, Houses, electronics, buy electronics, cheap electroincs',
};

export default Meta;
